import { render, staticRenderFns } from "./ModoAcao.vue?vue&type=template&id=a5659ac8&"
import script from "./ModoAcao.vue?vue&type=script&lang=js&"
export * from "./ModoAcao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports